export const MODAL_BACKGROUND_NO_SCROLL_CLASSNAME = 'body-no-scroll'
